import React from 'react'
import { ButtonLayouts, ButtonLayoutsProps } from './ButtonLayouts'

export const ButtonLayout: React.SFC<ButtonLayoutsProps> = props => (
  <ButtonLayouts type="layout" {...props} />
)
